import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createAddress,
  updateAddress,
  resetAddressState,
} from '../store/addressSlice';
import AddressList from '../components/AddressList';
import toast from 'react-hot-toast';

const NewAddress = () => {
  const dispatch = useDispatch();
  const { isLoading, success, error } = useSelector((state) => state.address);

  const [form, setForm] = useState({
    addressline1: '',
    addressline2: '',
    city: '',
    state: '',
    pincode: '',
    landmark: '',
    geolocation: '',
    googlelocationurl: '',
    lattitude: '',
    longitude: '',
    createdAt: '',
  });

  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEditing && selectedId) {
      dispatch(updateAddress({ id: selectedId, formData: form }));
    } else {
      dispatch(createAddress({ ...form, createdAt: new Date().toISOString() }));
    }
  };

  useEffect(() => {
    if (success) {
      toast.success(isEditing ? 'Address updated!' : 'Address created!');
      setForm({
        addressline1: '',
        addressline2: '',
        city: '',
        state: '',
        pincode: '',
        landmark: '',
        geolocation: '',
        googlelocationurl: '',
        lattitude: '',
        longitude: '',
        createdAt: '',
      });
      setIsEditing(false);
      setSelectedId(null);
      dispatch(resetAddressState());
    }
  }, [success, dispatch, isEditing]);

  // ✅ Handle row click to populate form
  const handleEdit = (address) => {
    setIsEditing(true);
    setSelectedId(address.id);
    setForm({ ...address });
  };

  return (
    <div className="space-y-10 px-6">
      <div className="max-w-3xl bg-white rounded shadow p-6 mx-auto space-y-4">
        <h2 className="text-2xl font-bold mb-4">
          {isEditing ? 'Edit Address' : 'New Address'}
        </h2>
        {error && <p className="text-red-500">{error}</p>}
        <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
          {Object.entries(form).map(([key, value]) => (
            <div key={key} className="col-span-1">
              <label className="block text-sm font-medium text-gray-600 capitalize">{key}</label>
              <input
                type="text"
                name={key}
                value={value}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded"
                required={['addressline1', 'city', 'state', 'pincode'].includes(key)}
                disabled={key === 'createdAt'} // disable manual editing
              />
            </div>
          ))}
          <div className="col-span-2">
            <button
              type="submit"
              disabled={isLoading}
              className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
            >
              {isLoading ? 'Saving...' : isEditing ? 'Update Address' : 'Create Address'}
            </button>
          </div>
        </form>
      </div>

      <AddressList onRowClick={handleEdit} />
    </div>
  );
};

export default NewAddress;
